import { useAuth } from 'context/auth';
import { isOnlyInCronoOptionVisible } from 'crono-fe-common/utils/crm-utils';
import useGetCrmSync from 'hooks/services/integrations/useGetCrmSync';
import { useState } from 'react';

/**
 * Whether a new record is created in the CRM or only in Crono. Until the user
 * picks, it follows the workspace's CRM sync default; without the choice (no
 * CRM to opt out of) records are always created in the CRM.
 */
export const useSyncTypeSelection = () => {
  const { user } = useAuth();
  const [pickedCreateInCrm, setPickedCreateInCrm] = useState<boolean | null>(
    null,
  );

  const { data: crmSync } = useGetCrmSync();

  const syncDefault = crmSync?.data.data
    ? crmSync.data.data.cronoToCrmSyncBehavior === 'CreateInCrmByDefault'
    : true;

  const isChoiceVisible = isOnlyInCronoOptionVisible(user);

  const createInCrm = isChoiceVisible
    ? (pickedCreateInCrm ?? syncDefault)
    : true;

  return {
    createInCrm,
    setPickedCreateInCrm,
    isChoiceVisible,
    /** The user picked something other than the default. */
    isDirty: createInCrm !== (isChoiceVisible ? syncDefault : true),
  };
};
